let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9P1aS")).then(() => parcelRequire('c8Q2n'));